import React, {CSSProperties, useEffect} from "react";
import styles from './SideModal.module.scss';
import {createPortal} from "react-dom";
import {CSSTransition} from "react-transition-group";
import XIcon from "../../Assets/SVG/XIcon";

interface IProps {
    visible: boolean;
    onCancel?: () => void;
    title: string;
    children?: any;
    modalStyle?: CSSProperties;
    closeOnOutsideClick?: boolean;
}
const SideModal = (props: IProps) => {

     useEffect(() => {
        if (props.closeOnOutsideClick) {
            const closeOnEscapeKeyDown = (e: any) => {
                if ((e.charCode || e.keyCode) === 27) {
                    if (props.visible && props.onCancel) {
                        props.onCancel()
                    }
                }
            };

            document.body.addEventListener("keydown", closeOnEscapeKeyDown);

            return () => {
                document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
            }
        }
    }, [props]);

   return createPortal(
        <CSSTransition
            in={props.visible}
            unmountOnExit
            timeout={{ enter: 0, exit: 300 }}
            classNames={{
                enterDone: styles.enterDone,
                enterActive: styles.enterActive,
                exit: styles.exit,
                exitActive: styles.exitActive
            }}
        >
            <div className={styles.modal} onMouseDown={() => {
                if (props.closeOnOutsideClick && props.onCancel) {
                    props.onCancel()
                }
            }}>
                <div className={styles.content} onMouseDown={e => e.stopPropagation()}>
                    <div className={styles.header}>
                        <span className={"h1 w-100"}>
                            {props.title}
                        </span>
                        <XIcon onClick={props.onCancel} style={{cursor: 'pointer'}} />
                    </div>
                    <div className={styles.body}>
                        {props.children}
                    </div>
                </div>
            </div>
        </CSSTransition>
        , document.getElementById('root')!)
}

export default SideModal
